import { capturePostHogEvent } from "./posthog";

// Events instrumenting the post-extract activation funnel:
//   1) first_export_clicked  — user clicks the Download/Export CTA
//   2) job_deleted           — user deletes a Job (hadExport tells us if it
//                              was a pre-export delete)
//
// Property shape is intentionally loose (Record<string, unknown>) so callers
// can omit fields they cannot determine from the frontend without lying.

export const trackFirstExportClicked = (props: {
  jobId?: number | string | null;
  userId?: number | string | null;
  jobStatus?: string | null;
  isFirstExportForUser?: boolean | null;
  planName?: string | null;
  pagesInJob?: number | null;
}) => {
  capturePostHogEvent("first_export_clicked", props);
};

export const trackJobDeleted = (props: {
  jobId?: number | string | null;
  userId?: number | string | null;
  jobStatus?: string | null;
  hadExport: boolean | null;
  jobAgeSeconds?: number | null;
  planName?: string | null;
}) => {
  capturePostHogEvent("job_deleted", props);
};
